import React from "react";

import cx from "classnames";

import LoadingSkeleton from "../LoadingSkeleton";
import styles from "./MenuItemSkeleton.scss";

type MenuItemSkeletonProps = {
  className?: string;
};

export default function MenuItemSkeleton({
  className,
}: MenuItemSkeletonProps): JSX.Element {
  return (
    <div className={cx(styles.wrapper, className)}>
      <LoadingSkeleton className={styles.image} isLoading={true} />
      <LoadingSkeleton className={styles.name} isLoading={true} />
      <LoadingSkeleton className={styles.restaurant} isLoading={true} />
    </div>
  );
}
